import {Component, Input} from '@angular/core';
import {ActivatedRoute, RouterLink} from '@angular/router';
import {ProductDetail} from '../../generic/classes/product.detail';
import {ProductPrices} from '../../generic/classes/product.prices';
import {ApplicationService} from '../../generic/service/application.service';
import {ProductService} from '../../generic/service/product.service';
import {ShoppingCartService} from '../../generic/service/shoppingcart.service';
import {UserService} from '../../generic/service/user.service';
import {CustomDatePipe} from '../../generic/pipes/custom.date.pipe';
import {DecimalPipe} from '@angular/common';
import {BuyOptionsComponent} from './item/buy.options.component';
import {ProductFavoriteComponent} from './item/favorite.component';
import {ProductMoreAvailableComponent} from '../../generic/component/products/product.more.available.component';
import {ShoppingCartLine} from '../../generic/classes/shoppingcartline';
import {ProductTypes} from '../../generic/classes/product.types.enum';
import {ProductQuantityUtils} from '../../generic/utils/product.quantity.utils';

@Component({
	selector: 'productdetail-product-price-and-buy-button',
	templateUrl: './productdetail.product.price.component.html',
	styleUrls: ['./productdetail.product.price.component.scss'],
	standalone: true,
	imports: [
		RouterLink,
		ProductFavoriteComponent,
		BuyOptionsComponent,
		ProductMoreAvailableComponent,
		DecimalPipe,
		CustomDatePipe
	]
})
export class ProductDetailProductPriceComponent {
	type: string;

	@Input()
	public productDetail: ProductDetail;

	@Input()
	public productPrices: ProductPrices;

	constructor(
		private activatedRoute: ActivatedRoute,
		private productService: ProductService,
		private shoppingCartService: ShoppingCartService,
		public applicationService: ApplicationService,
		public userService: UserService
	) {
	}

	get activeLine(): ShoppingCartLine | null | undefined {
		if (!this.userService.getUser()) {
			return null;
		}

		const shoppingCartLines = this.shoppingCartService.activeShoppingCartLines;

		if (!shoppingCartLines) {
			return null;
		}

		return shoppingCartLines.find(
			line =>
				line.priceListLineNo === this.productDetail.priceListLineNo &&
				line.priceListNo === this.productDetail.priceListNo,
		);
	}

	/**
	 * Subscribe to the params from the activated route
	 */
	ngOnInit() {
		this.activatedRoute.params.subscribe(params => {
			this.type = params.type;
		});
	}

	isStockProduct() {
		return this.productDetail.type === this.productService.TYPE_STOCK;
	}

	isProductSoldOut(): boolean {
		return parseInt(this.type) === ProductTypes.SOLD_OUT;
	}

	getQuantity(): number {
		if (this.activeLine) {
			const quantity =
				this.activeLine.quantity / this.activeLine.qtyByBox;

			return Math.round(quantity);
		}

		return 0;
	}

	/**
	 * Take the quantity already ordered into account
	 *
	 * @returns {number}
	 */
	getAvailableQuantity(): number {
		return ProductQuantityUtils.getAvailableBoxQuantity(
			this.productDetail,
			this.shoppingCartService.activeShoppingCartLines,
		);
	}
}
